import { HostBroadcastStatus } from "@playcastdotio/CoreTypes";
import { PlaycastMessage, PlaycastMessageBroadcastStatus, PlaycastMessageSource } from "../types";
import { formatMessage } from "./_util/formatMessage";

const target = 'hub';

export const broadcastStatus = (
  status: HostBroadcastStatus,
  hostAuthId?: string,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageBroadcastStatus> => {
  hostAuthId = hostAuthId || 'experimental';
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageBroadcastStatus = {
    target,
    action: 'broadcastStatus',
    isReply: false,
    message: { 
      status,
    },
  };
  return formatMessage(hostAuthId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageBroadcastStatus>;
};